import React from 'react'
import { Link } from 'react-router-dom'
import { ROUTER } from '../router/constants'
import { Box, Button, Grid, Typography, useMediaQuery, useTheme } from '@mui/material'

const Enter = () => {


  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))


  return (
    <div className='container' style={{ padding: '60px 40px', backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)' }}>
      <Typography
        variant={isLargeScreen ? 'h1' : 'h2'}
        align="center"
        color='black'
        sx={{
          fontWeight: isLargeScreen ? 600 : 700,
          color: 'black',
          mb: '64px'
        }}
      >
        {'ورود'}
      </Typography>
      <Grid mb={'64px'}>
        <Typography color={theme.palette.info.dark} variant={isLargeScreen ? 'h5' : 'h6'} align="center" sx={{ mb: '20px' }}>کد QR زیر را مقابل اسکنر درب نگه دارید</Typography>
        <Grid display={'flex'} justifyContent={'center'} alignItems={'center'} width={'75%'} height={'full'} mx={'auto'}>
          <img src='./assets/image/qr-code.png' alt='' style={{ width: '100%', height: "100%" }} />
        </Grid>
      </Grid>
      <Box sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2
      }}>
        <Box sx={{ width: '50%' }}>
          <Button
            component={Link}
            to={ROUTER.ROOM}
            fullWidth
            variant="contained"
            sx={{
              height: '48px',
              py: 1.5,
              px: 3,
              borderRadius: 1,
              fontSize: isLargeScreen ? '16px' : '14px',
              '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: 6
              },
              transition: 'all 0.3s'
            }}
          >
            وارد شدم
          </Button>
        </Box>
        <Box sx={{ width: '50%' }}>
          <Button
            component={Link}
            to={ROUTER.AUTHENTICATION}
            fullWidth
            variant="outlined"
            sx={{
              height: '48px',
              py: 1.5,
              px: 3,
              borderRadius: 1,
              fontSize: isLargeScreen ? '16px' : '14px',
              color: 'primary.main',
              borderColor: 'primary.main',
              '&:hover': {
                transform: 'scale(1.05)',
                boxShadow: 6,
                borderColor: 'primary.main'
              },
              transition: 'all 0.3s'
            }}
          >
            بازگشت
          </Button>
        </Box>
      </Box>
    </div>
  )
}

export default Enter
